import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Action } from 'src/app/pages/action/action.model';

@Component({
  selector: 'app-action-dialog',
  templateUrl: './action-dialog.component.html',
  styleUrls: ['./action-dialog.component.scss'],
})
export class ActionDialogComponent {
  public actionType: string;
  public action?: Action;

  public actionId?: string;

  constructor(
    public dialogRef: MatDialogRef<ActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any | null
  ) {
    if (data) {
      this.action = data.action;
      this.actionType = data.actionType;

      this.actionId = data.action?.id;
    }
    dialogRef.disableClose = true;
    dialogRef.keydownEvents().subscribe((event) => {
      if (event.key === 'Escape') {
        this.onEscape();
      }
    });
  }

  public save(): void {
    const action = {
      actionType: this.actionType,
      action: this.action,
    };
    this.dialogRef.close(action);
  }

  private onEscape(): void {
    this.dialogRef.close(false);
  }
}
